/* eslint-disable no-shadow */
/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { convertToClassName } from '@components/NColumnGrid/utils'
import { HTMLTagsForHowTo } from '@configs/howToHTMLTag'
import styles from './accordion.module.scss'
import CheckBoxInputField from './CheckBoxInputField'
import AccordionIcons from './AccordionIcons'

const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

interface AccordionItemProps {
  item: {
    id: Number
    accordionHeading: string
    accordionType: string
    accordionContent: string
    accordionImage: any
  }
  index: number
  type: string
  isHowToComp?: boolean
}

const AccordionItem: React.FC<AccordionItemProps> = ({ item, index, type, isHowToComp = false }) => {
  const generateClassName = item => {
    const accordionClassName = item.tabSection ? convertToClassName(item.tabSection) : ''

    return `${accordionClassName} ${styles.accordion}`
  }

  const getModifiedHtml = tableContent => {
    const $ = cheerio.load(tableContent, null, false)

    $('p').each((_index, element) => {
      const $p = $(element)
      if ($p.html().trim() === '&nbsp;') {
        $p.remove()
      }
    })

    $('a').each((_index, element) => {
      const $a = $(element)
      $a.attr('target', '_blank')
    })

    const modifiedHTML = $.html()
    return modifiedHTML
  }

  const modifiedAccordionContent = getModifiedHtml(item?.accordionContent)
  const { ItemTag } = HTMLTagsForHowTo.accordion(isHowToComp)

  return (
    <ItemTag className={generateClassName(item)}>
      <div className={styles.accordionItem}>
        <CheckBoxInputField item={item} index={index} type={type} />
        <label htmlFor={`accordion-item-${type}-${item?.id}`} className={styles.accordionHeader}>
          <h4>{item?.accordionHeading}</h4>
          <AccordionIcons accordionItem={item} />
        </label>
        <div className={styles.accordionContent}>
          <span className={styles.para} dangerouslySetInnerHTML={{ __html: modifiedAccordionContent }} />
        </div>
      </div>
    </ItemTag>
  )
}

export default AccordionItem
